/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invitationDataRoleSchema = z.enum(['member', 'admin', 'jobillan', 'recruiter'])

export type InvitationDataRoleSchema = z.infer<typeof invitationDataRoleSchema>
